<template>
  <div
    class="bg-white border-t border-solid ps-border-gray-200 px-4 py-5 sm:px-8"
  >
    <div class="sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
      <span class="flex justify-end w-full sm:col-start-2">
        <span class="rounded-md shadow-sm">
          <button
            type="button"
            @click="routeToControls"
            class="max-w-xs inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-500 shadow-sm hover:text-gray-800 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
          >
            <svg
              class="-ml-1 mr-3 h-5 w-5 opacity-50"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                stroke-width="2"
              ></path>
            </svg>
            Done
          </button>
        </span>
      </span>
      <span class="flex w-full sm:mt-0 sm:col-start-1">
        <span>
          <p class="ps-text-xxs ps-text-gray-400">Picnic.team: Version 1.0</p>
          <p class="ps-text-xxs ps-mt-1 ps-text-gray-400">
            &copy; {{ year }} SPTTR, LLC
            <a
              class="ps-inline-block ps-ml-4"
              :href="finePrintUrl"
              target="_blank"
              >Fine Print</a
            >
          </p>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
import { mapMutations } from '@picnic-software/vuex'
import packageJSON from './../../package.json'

export default {
  name: 'TheFooter',
  methods: {
    ...mapMutations({
      routeToControls: 'router/controls'
    })
  },
  computed: {
    version() {
      return packageJSON.version
    },
    year() {
      return new Date().getFullYear()
    },
    finePrintUrl() {
      return `${process.env.VUE_APP_MARKETING_URL}/policies`
    }
  }
}
</script>
